import { jsxs as n, jsx as i } from "react/jsx-runtime";
import I from "../LeadModal/LeadModal.js";
import L from "../ScheduleShowingButton/ScheduleShowingButton.js";
import "@material-ui/core/Box";
import l from "@material-ui/core/Button";
import k from "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import A from "@material-ui/core/CardContent";
import U from "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import d from "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import z from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import D from "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import M from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import T from "@material-ui/core/withWidth";
import j from "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import P from "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import W from "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { useSessionContext as B, getFirstImage as $, Link as E, Badge as h, getBathroomCount as F, getAddressDescription as R, showToast as V } from "@propify-tenant-client/common";
import { getSdkUnitListClassName as e } from "../../utils/sdk.js";
import { getUnitStatusLabel as G, getPetPolicyText as q, getApplyNowLink as H } from "../../utils/utils.js";
import { isSDK as m, LeadStatus as K, LeadService as O, handleError as _ } from "@propify-tenant-client/services";
import { formatCurrency as J } from "@propify/components";
import g from "big.js";
import o from "classnames";
import y from "lodash/isEmpty";
import { useState as Q } from "react";
const X = (t) => z({
  root: {
    flex: 1,
    display: "flex",
    margin: "0.5em",
    maxWidth: "100%",
    justifyContent: "center",
    [t.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  details: {
    display: "flex",
    flex: 1,
    flexDirection: "column"
  },
  content: {
    flex: "1 0 auto"
  },
  header: {
    fontSize: "1.5em"
  },
  icons: {
    display: "flex",
    flex: 1
  },
  icon: {
    display: "flex",
    flex: 0,
    marginRight: "1em",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center"
  },
  iconImage: {
    margin: "0.2em",
    marginRight: "0.3em"
  },
  cover: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: 230,
    [t.breakpoints.down("sm")]: {
      width: "100%",
      height: 200
    }
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "0.3em"
  },
  button: {
    margin: "0.2em",
    textAlign: "center",
    textDecoration: "none"
  },
  hidden: {
    visibility: "hidden"
  },
  price: {
    display: "flex"
  },
  badges: {
    display: "flex",
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "start",
    fontSize: "0.9em"
  },
  overlay: {
    position: "absolute",
    top: 0,
    padding: "0.5em 1em",
    fontWeight: "bold",
    color: "#fff",
    background: "rgba(0, 0, 0, 0.75)",
    borderRadius: "0  0 4px 0"
  }
}), Y = ({ classes: t, onLetsGoTouringModalOpen: b, unit: r }) => {
  var u, f;
  const [x, s] = Q(!1), { login: c } = B(), N = (a) => {
    a.stopPropagation(), s(!0);
  }, S = (a) => {
    a && a.stopPropagation(), s(!1);
  }, v = (a) => {
    const C = {
      source: m() ? "website" : "publicClient",
      status: K.ACTIVE,
      message: a.message || void 0,
      propertyId: r.property.id,
      floorplanId: r.floorplanId,
      unitId: r.id,
      ...y(c) ? {
        firstName: a.firstName || void 0,
        lastName: a.lastName || void 0,
        phone: a.phone || void 0,
        email: a.email || void 0
      } : {}
    };
    O.create(C).then(() => V("success", "Submission successful")).catch((w) => {
      _(w, { toastMessage: "An error occurred, please try again" });
    });
  }, p = (u = $(r.property.listingImages)) == null ? void 0 : u.thumbnailUrl;
  return /* @__PURE__ */ n(k, { className: o(t.root, e("unit-card-root")), children: [
    /* @__PURE__ */ n(
      U,
      {
        component: E,
        to: m() ? `/units/${r.id}` : `units/${r.id}`,
        className: o(t.cover, e("unit-card-cover")),
        children: [
          /* @__PURE__ */ i("span", { className: o(t.overlay, e("unit-card-overlay")), children: G(r) }),
          /* @__PURE__ */ i(
            "div",
            {
              style: {
                width: "100%",
                height: "100%",
                background: p ? `url("${p}")` : "",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundColor: "#eaeaea"
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ n("div", { className: o(t.details, e("unit-card-details")), children: [
      /* @__PURE__ */ i(
        A,
        {
          className: o(t.content, e("unit-card-content")),
          children: /* @__PURE__ */ n(
            d,
            {
              container: !0,
              spacing: 1,
              className: o(t.header, e("unit-card-header")),
              children: [
                /* @__PURE__ */ n(
                  d,
                  {
                    item: !0,
                    xs: 12,
                    className: o(t.price, e("unit-card-price")),
                    children: [
                      /* @__PURE__ */ i("span", { children: J(g(r.listedRent ?? 0).round(0, g.roundUp), {
                        noEmptyDecimals: !0
                      }) }),
                      /* @__PURE__ */ n(
                        "div",
                        {
                          className: o(t.badges, e("unit-card-badges")),
                          children: [
                            !!((f = r.property) != null && f.virtualTourUrl) && /* @__PURE__ */ i(h, { color: "#3489FF", children: "Virtual Tour" }),
                            /* @__PURE__ */ i(h, { color: "#3489FF", children: "Self Showing" })
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ n(
                  d,
                  {
                    item: !0,
                    xs: "auto",
                    lg: 12,
                    className: o(t.icons, e("unit-card-icons")),
                    children: [
                      /* @__PURE__ */ n("div", { className: o(t.icon, e("unit-card-icon")), children: [
                        /* @__PURE__ */ i(
                          P,
                          {
                            className: o(
                              t.iconImage,
                              e("unit-card-icon-image")
                            )
                          }
                        ),
                        /* @__PURE__ */ i("span", { children: r.bedroomCount })
                      ] }),
                      /* @__PURE__ */ n("div", { className: o(t.icon, e("unit-card-icon")), children: [
                        /* @__PURE__ */ i(
                          j,
                          {
                            className: o(
                              t.iconImage,
                              e("unit-card-icon-image")
                            )
                          }
                        ),
                        /* @__PURE__ */ i("span", { children: F(r) })
                      ] }),
                      /* @__PURE__ */ n("div", { className: o(t.icon, e("unit-card-icon")), children: [
                        /* @__PURE__ */ i(
                          W,
                          {
                            className: o(
                              t.iconImage,
                              e("unit-card-icon-image")
                            )
                          }
                        ),
                        /* @__PURE__ */ i("span", { style: { whiteSpace: "nowrap", fontSize: "80%" }, children: q(r.property.petPolicy) })
                      ] })
                    ]
                  }
                ),
                /* @__PURE__ */ i(d, { item: !0, xs: 12, children: /* @__PURE__ */ i(M, { variant: "subtitle1", color: "textSecondary", children: R(r.property.address) }) })
              ]
            }
          )
        }
      ),
      /* @__PURE__ */ n("div", { className: o(t.actions, e("unit-card-actions")), children: [
        /* @__PURE__ */ i(
          l,
          {
            href: m() ? `${window.location.pathname}#/units/${r.id}` : `/units/${r.id}`,
            size: "small",
            variant: "contained",
            color: "primary",
            className: o(t.button, e("unit-card-button")),
            children: "Show Details"
          }
        ),
        r.listingStatus === "ACTIVE" ? /* @__PURE__ */ i(
          L,
          {
            size: "small",
            unit: r,
            className: o(t.button, e("unit-card-button")),
            onLetsGoTouringModalOpen: () => {
              b();
            }
          }
        ) : /* @__PURE__ */ i(
          l,
          {
            size: "small",
            variant: "contained",
            color: "primary",
            className: o(t.button, e("unit-card-button")),
            onClick: N,
            children: "Add to Waiting List"
          }
        ),
        /* @__PURE__ */ i(
          l,
          {
            size: "small",
            variant: "contained",
            color: "primary",
            className: o(t.button),
            href: H(r) ?? "",
            target: m() ? "_blank" : void 0,
            rel: m() ? "noopener noreferrer" : void 0,
            children: "Apply Now"
          }
        )
      ] })
    ] }),
    x && /* @__PURE__ */ i(
      I,
      {
        open: !0,
        onClose: S,
        onSubmit: v,
        isLogged: !y(c),
        login: c
      }
    )
  ] });
}, no = T()(D(X, { name: "UnitCard" })(Y));
export {
  no as default
};
//# sourceMappingURL=UnitCard.js.map
